import type { Router } from 'vue-router'
import {
  buildColumnFromDeckQuery,
  convertQueryParamToSingle
} from '@/router/utils'
import { preferredLocale } from '@/plugins/i18n'

export default function useAiRoute(router: Router) {
  router.beforeEach(to => {
    if (!to.path.startsWith('/chat')) {
      return
    }

    const promptId = convertQueryParamToSingle(to.query['prompt-id'])
    // `summary` : alias des anciens liens
    to.meta.promptId = promptId === 'summary' ? 'digest' : promptId
    // Avec digest, q et les autres clés de /new décrivent la recherche à synthétiser (et non un message)
    to.meta.searchParams =
      to.meta.promptId === 'digest'
        ? buildColumnFromDeckQuery(to.query, preferredLocale.value).params
        : undefined
    to.meta.docId = convertQueryParamToSingle(to.query['doc-id'])
  })
}
